// Reads the current Home nav accent color from HomeNavAccentContext.

import { useContext } from 'react';
import { HomeNavAccentContext } from '../contexts/HomeNavAccentContext';
import type { PlayerColorFamily } from '@/styles/playerColors';

export function useHomeNavAccent(): PlayerColorFamily | null {
  return useContext(HomeNavAccentContext)?.activeColorFamily ?? null;
}
